import template from './sidebar.html';
import './sidebar.scss';

export default {
  template,
};
